import router from './router'
import store from '../../store'

const whiteList = ['/login', '/auth-redirect']
router.beforeEach(async(to, from, next) => {

  // determine whether the user has obtained his permission roles through getInfo
  const isLogin = store.getters.isLogin
  const role = store.getters.role
  // 登陆或游客的身份
  if(isLogin || role === 'visitor' || whiteList.indexOf(to.path) !== -1){
    return next()
  }

  try {
    await store.dispatch('loginInfo')
    next({ ...to, replace: true })
  } catch (error) {
    next({path: '/login', query: { scene: error.message==311?'bind':'login', redirect: to.fullPath}})
  }
})

router.afterEach(() => {
  // finish progress bar
})
